module.exports = __webpack_public_path__ + "img/imgImgHome03.9613b462.svg";